export const createEncodingError = () => new DOMException('', 'EncodingError');
//# sourceMappingURL=encoding-error.js.map